module.exports = __webpack_public_path__ + "static/img/pic01.a06f3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunkang/pic01.png
// module id = mo4g
// module chunks = 2